// extracted by mini-css-extract-plugin
module.exports = {"img":"SettingsAnimation_img__3w-Ef","rotation":"SettingsAnimation_rotation__vAjeH"};